// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"59":"c3925f4b","129":"f13cf917","147":"185dc69e","402":"b9287a18","424":"d86d64d8","551":"5512b682","589":"57fa54c9","604":"f761bc4c","628":"5ec8e56f","685":"575f169d","817":"a202b704","850":"363ee9dd","865":"1c5b1316","920":"ad39ba48","967":"cbdfd97b","996":"116d747c"}[chunkId] + ".js";
};